export default function classNames(
  componentName: string,
  modifiers: {
    [key: string]: boolean
  } = {},
  suffix?: string | string[]
): string {
  const modifiersList = Object.keys(modifiers)
    .reduce(
      (accumulator: string[], name: string) =>
        modifiers[name] ? [...accumulator, name] : accumulator,
      []
    )
    .map((name: string) => `${componentName}--${name}`)

  const suffixArray = (Array.isArray(suffix) ? suffix : [suffix]).filter(Boolean)

  return [componentName, ...modifiersList, ...suffixArray].join(' ')
}
